import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        display: block;\n        margin-left: ", "px;\n        ", "\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    opacity: 0;\n    z-index: -1;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        display: block;\n        position: relative;\n        box-sizing: border-box;\n        width: 20px;\n        height: 20px;\n        flex-shrink: 0;\n        border: 2px solid ", ";\n        border-radius: 50%;\n        background-color: ", ";\n        ", "\n\n        &:hover,\n        &:focus {\n            border-color: ", ";\n        }\n\n        &:active {\n            border-color: ", ";\n        }\n\n        ", "\n        ", "\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    vertical-align: middle;\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        pointer-events: none;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        &,\n        &:hover,\n        &:focus {\n            border-color: ", ";\n\n            &::before {\n                background-color: ", ";\n            }\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        border-color: ", ";\n\n        &:hover,\n        &:focus {\n            border-color: ", ";\n\n            &::before {\n                background-color: ", ";\n            }\n        }\n\n        &:active {\n            border-color: ", ";\n\n            &::before {\n                background-color: ", ";\n            }\n        }\n\n        &::before {\n            content: '';\n            display: block;\n            box-sizing: border-box;\n            position: absolute;\n            left: 3px;\n            top: 3px;\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            background-color: ", ";\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef, useRef } from 'react';
import styled, { css } from 'styled-components';
import { transitions, typography } from '../mixins';
import { noop } from '../helpers';

var checked = function checked(_ref) {
  var primary = _ref.theme.palette.primary,
      checked = _ref.checked;

  if (!checked) {
    return null;
  }

  return css(_templateObject(), primary.main, primary.hover, primary.hover, primary.active, primary.active, primary.main);
};

var disabled = function disabled(_ref2) {
  var gray = _ref2.theme.palette.gray,
      disabled = _ref2.disabled;

  if (!disabled) {
    return null;
  }

  return css(_templateObject2(), gray.gray200, gray.gray200);
};

var disabledLabel = function disabledLabel(_ref3) {
  var disabled = _ref3.disabled;

  if (!disabled) {
    return null;
  }

  return css(_templateObject3());
};

var StyledLabel = styled.label(_templateObject4(), disabledLabel);
var Container = styled.span(function (_ref4) {
  var palette = _ref4.theme.palette;
  return css(_templateObject5(), palette.primary.main, palette.common.white, transitions(['border-color']).easeOut().shortest(), palette.primary.hover, palette.primary.active, checked, disabled);
});
var StyledCheckbox = styled.input(_templateObject6());
var TextContainer = styled.span(function (_ref5) {
  var unit = _ref5.theme.unit;
  return css(_templateObject7(), unit * 2, typography('body2'));
});
export var Radio = forwardRef(function (_a, ref) {
  var _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$checked = _a.checked,
      checked = _a$checked === void 0 ? false : _a$checked,
      _a$inputRef = _a.inputRef,
      inputRef = _a$inputRef === void 0 ? useRef(null) : _a$inputRef,
      children = _a.children,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? noop : _a$onChange,
      props = __rest(_a, ["disabled", "checked", "inputRef", "children", "onChange"]);

  return React.createElement(StyledLabel, {
    checked: checked,
    disabled: disabled,
    ref: ref
  }, React.createElement(Container, {
    checked: checked,
    disabled: disabled
  }, React.createElement(StyledCheckbox, Object.assign({
    type: 'radio',
    ref: inputRef,
    checked: checked,
    disabled: disabled,
    onChange: onChange
  }, props))), children && React.createElement(TextContainer, null, children));
});
Radio.displayName = 'Radio';